import React, { Fragment } from 'react';
import moment from 'moment';
import { Skeleton } from '@mantine/core';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

import { TbEditCircle } from 'react-icons/tb';
import ESwitch from 'libs/ui/src/Switch/ESwitch';
import { EPageTitle, EButton, ETable, ELabelView, ELoader, EBadge } from 'libs/ui';

import PageLayout from 'PageLayout';

import useCommissionB2B from './Hooks/useCommissionB2B';
import ETableTooltipData from 'libs/ui/src/table/ETableTooltipData';

export default function CommissionB2B() {

    const {
        navigate,
        isLoading,
        goToNextPage,
        goToPreviousPage,
        disablePrev,
        disableNext,
        flightCommissionList,
        expandedIndex,
        setExpandedIndex,
        isUpdatingStatus,
        updateCommissionStatus
    } = useCommissionB2B();

    return (
        <PageLayout>
            <EPageTitle
                title="Commission B2B"
                end={
                    <div className="flex gap-2">
                        <EButton
                            onClick={() => navigate('/group-settings/create-commission-b2b')}
                        >Create Commission</EButton>
                    </div>
                }
            />
            <div>
                <ETable loading={isLoading}>
                    <thead>
                        <tr>
                            <th></th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Groups</th>
                            <th>Flight Type</th>
                            <th>Search Type</th>
                            <th>Cabin</th>
                            <th>Class</th>
                            <th>Supplier</th>
                            <th>Airlines</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>

                    <tbody>
                        {
                            flightCommissionList.map((commission, index) => (
                                <Fragment key={index + "_fc"}>
                                    <tr>
                                        <td className={`${expandedIndex === index ? "border-l-2 border-blue-600" : ""}`}>
                                            {
                                                expandedIndex === index
                                                    ?
                                                    <FaChevronUp className="cursor-pointer" onClick={() => setExpandedIndex(null)} />
                                                    :
                                                    <FaChevronDown className="cursor-pointer" onClick={() => setExpandedIndex(index)} />
                                            }
                                        </td>
                                        <td>{moment(commission.startDate).format("DD-MM-YYYY")}</td>
                                        <td>{moment(commission.endDate).format("DD-MM-YYYY")}</td>
                                        <td>
                                            {
                                                commission.affiliateGroup?.length
                                                    ?
                                                    ETableTooltipData(commission.affiliateGroup.map((group) => group.name))
                                                    :
                                                    "N/A"
                                            }
                                        </td>
                                        <td>
                                            {
                                                commission.flightTypes?.length
                                                    ?
                                                    commission.flightTypes.map((type) => type.key)?.join(", ")
                                                    :
                                                    "N/A"
                                            }
                                        </td>
                                        <td>
                                            {
                                                commission.flightSearchTypes?.length
                                                    ?
                                                    commission.flightSearchTypes.map((type) => type.key)?.join(", ")
                                                    :
                                                    "N/A"
                                            }
                                        </td>
                                        <td>
                                            {
                                                commission.flightCabin?.length
                                                    ?
                                                    ETableTooltipData(commission.flightCabin.map((cabin) => cabin.key))
                                                    :
                                                    "N/A"
                                            }
                                        </td>
                                        <td>
                                            {
                                                commission.flightClass?.length
                                                    ?
                                                    ETableTooltipData(commission.flightClass.map((classs) => classs.key))
                                                    :
                                                    "N/A"
                                            }
                                        </td>
                                        <td>
                                            {
                                                commission.ticketSupplier?.length
                                                    ?
                                                    ETableTooltipData(commission.ticketSupplier.map((supplier) => supplier.name))
                                                    :
                                                    "N/A"
                                            }
                                        </td>
                                        <td>
                                            {
                                                commission.flightAirline?.length
                                                    ?
                                                    ETableTooltipData(commission.flightAirline.map((airline) => airline.name))
                                                    :
                                                    "N/A"
                                            }
                                        </td>
                                        <td>
                                            <EBadge
                                                variant="light"
                                                color={commission.status ? "green" : "red"}
                                            >{commission.status ? "Active" : "Inactive"}</EBadge>
                                        </td>
                                        <td>
                                            <div className="flex items-center gap-2">
                                                {
                                                    isUpdatingStatus
                                                        ?
                                                        <ELoader type="dots" />
                                                        :
                                                        <ESwitch
                                                            // withConfirmation
                                                            label={''}
                                                            loading={isUpdatingStatus}
                                                            checked={commission.status}
                                                            onChange={() => updateCommissionStatus(commission)}
                                                        />
                                                }
                                                <TbEditCircle
                                                    size={20}
                                                    className="cursor-pointer hover:text-blue-600"
                                                    onClick={() => navigate(
                                                        `/group-settings/create-commission-b2b?service=${"FLIGHT"}&id=${commission.id}`,
                                                        { state: { commission: commission } }
                                                    )}
                                                />
                                            </div>
                                            {/* <Popover
                                                        withArrow
                                                        position="left"
                                                        shadow="md"
                                                        transitionProps={{ transition: "fade-left", duration: 300 }}
                                                    >
                                                        <Popover.Target>
                                                            <div>
                                                                <MdMoreVert className="cursor-pointer" />
                                                            </div>
                                                        </Popover.Target>
                                                        <Popover.Dropdown>
                                                            <div className="flex flex-col gap-2">
                                                                <TbEditCircle
                                                                    size={22}
                                                                    className="cursor-pointer hover:text-blue-600"
                                                                // onClick={() => navigate(`/group-settings/create-commission-b2b?id=${commission.id}`)}
                                                                />
                                                                <ESwitch
                                                                    size="xs"
                                                                    label={""}
                                                                    checked={false}
                                                                    onChange={() => { }}
                                                                />
                                                            </div>
                                                        </Popover.Dropdown>
                                                    </Popover> */}
                                        </td>
                                    </tr>

                                    {
                                        expandedIndex === index
                                            ?
                                            <tr>
                                                <td className="border-l-2 border-blue-600"></td>
                                                <td colSpan={11}>
                                                    <div className="grid grid-cols-5 gap-6">
                                                        {
                                                            commission.commissionChargeWithAmountTypes.map(
                                                                (charge, index) => !["OTHER_TAXES", "INCENTIVE", "CASHBACK"].includes(charge.commissionFormCharge.value)
                                                                    ? (
                                                                        <ELabelView
                                                                            size="xs"
                                                                            key={index + "_com_charge"}
                                                                            label={charge.commissionFormCharge?.key}
                                                                            value={`${charge.amount} ${charge.feeType}`}
                                                                        />
                                                                    ) : <></>)
                                                        }
                                                    </div>
                                                </td>
                                            </tr>
                                            :
                                            <></>
                                    }
                                </Fragment>
                            ))
                        }
                    </tbody>
                </ETable>
            </div>
        </PageLayout>
    )
}